import React from 'react';
import PropTypes from 'prop-types';
import resx from '../../utilities/resx';
import { RESX_LISTINGS } from '../../Constants';

const IsSoldLabel = props => {
	let soldLabelText;

	// if TRANSACTION TYPE of listing is Lease (ListingTransactionType: 1), show "Leased" text
	if (props.isSold) {
		if (props.listingTransactionType === 1) {
			soldLabelText = resx(RESX_LISTINGS, 'LEASED_TEXT');
		} else if (props.listingTransactionType === 0) {
			soldLabelText = resx(RESX_LISTINGS, 'SOLD_TEXT');
		}
	}


	return (
		props.isSold ? (
			<span className="re-post-label listing-sold">
				<span>{soldLabelText}</span>
			</span>
		) : null
	)
}
	


IsSoldLabel.propTypes = {
	listingTransactionType: PropTypes.number.isRequired,
	isSold: PropTypes.bool.isRequired
}

export default IsSoldLabel;
